export enum LayoutOptions {
  HAS_SIDENAV = 'hasSidenav',
  /**
   * The footer strip, with the version section on its left, the Issues tab and the floating
   * console. Meant for a route that carries the app version, read from the merged activated-route
   * data so every page under it inherits it: the version section shows that version and the issues
   * check posts against `:appVersionId`, so the strip has nothing to do where there is none.
   */
  HAS_FOOTER = 'hasFooter',
  IS_RUNNING_INSTANCE = 'isRunningInstance',
}
